/* AIM MATRIX — theme.js
   Vanilla JS, no dependencies, deferred. Everything degrades gracefully:
   with JS off, forms still post to Shopify and links still navigate. */
(function () {
  'use strict';

  var focusReturn = null;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function announce(message) {
    var region = $('[data-cart-live-region]');
    if (region) region.textContent = message;
  }

  /* ---------------- Overlay panels (mobile nav + cart drawer) ---------------- */
  function openPanel(panel) {
    if (!panel) return;
    focusReturn = document.activeElement;
    panel.setAttribute('data-open', 'true');
    panel.removeAttribute('inert');
    var overlay = $('[data-overlay]');
    if (overlay) overlay.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    var focusable = panel.querySelector('button, a[href], input, select, textarea');
    if (focusable) focusable.focus();
    $$('[aria-controls="' + panel.id + '"]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'true');
    });
  }

  function closePanels() {
    $$('[data-panel]').forEach(function (panel) {
      panel.setAttribute('data-open', 'false');
      panel.setAttribute('inert', '');
      $$('[aria-controls="' + panel.id + '"]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    });
    var overlay = $('[data-overlay]');
    if (overlay) overlay.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
    if (focusReturn && focusReturn.focus) focusReturn.focus();
    focusReturn = null;
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-panel-open]');
    if (opener) {
      event.preventDefault();
      openPanel(document.getElementById(opener.getAttribute('aria-controls')));
      return;
    }
    if (event.target.closest('[data-panel-close]') || event.target.closest('[data-overlay]')) {
      event.preventDefault();
      closePanels();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if ($('[data-panel][data-open="true"]')) closePanels();
  });

  /* Trap focus inside an open panel */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var panel = $('[data-panel][data-open="true"]');
    if (!panel) return;
    var items = $$('a[href], button:not([disabled]), input, select, textarea', panel).filter(function (el) {
      return el.offsetParent !== null;
    });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* ---------------- Cart ---------------- */
  function refreshCartUI() {
    return fetch(window.routes.cart_url + '?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html');
        var newDrawer = fresh.querySelector('[data-cart-contents]');
        var current = $('[data-cart-contents]');
        if (newDrawer && current) current.innerHTML = newDrawer.innerHTML;
        return fetch(window.routes.cart_url + '.js');
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      });
  }

  function setButtonLoading(button, loading, label) {
    if (!button) return;
    button.toggleAttribute('aria-disabled', loading);
    if (loading) {
      button.dataset.label = button.textContent;
      button.textContent = label || 'Adding…';
    } else if (button.dataset.label) {
      button.textContent = button.dataset.label;
    }
  }

  /* Add to cart without a page reload */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-cart-add]');
    if (!form) return;
    event.preventDefault();

    var button = form.querySelector('[data-direct-checkout]') || form.querySelector('[type="submit"]');
    var errorBox = form.querySelector('[data-cart-error]');
    if (errorBox) errorBox.hidden = true;
    setButtonLoading(button, true);

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) { return res.json().then(function (body) { return { ok: res.ok, body: body }; }); })
      .then(function (result) {
        if (!result.ok) throw new Error(result.body.description || window.strings.cartError);
        return refreshCartUI().then(function () {
          announce(result.body.title + ' added to your cart');
          openPanel($('#CartDrawer'));
        });
      })
      .catch(function (error) {
        if (errorBox) {
          errorBox.textContent = error.message;
          errorBox.hidden = false;
        }
      })
      .finally(function () { setButtonLoading(button, false); });
  });

  /* Quantity changes + removals inside the drawer and cart page */
  document.addEventListener('click', function (event) {
    var control = event.target.closest('[data-line-change]');
    if (!control) return;
    event.preventDefault();
    updateLine(control.dataset.line, control.dataset.lineChange);
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-line-input]');
    if (!input) return;
    updateLine(input.dataset.line, input.value);
  });

  function updateLine(line, quantity) {
    fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    })
      .then(function () { return refreshCartUI(); })
      .then(function () {
        announce('Cart updated');
        if (document.body.classList.contains('template-cart')) window.location.reload();
      });
  }

  /* ---------------- Quantity steppers ---------------- */
  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.parentElement.querySelector('input');
    var next = Number(input.value) + Number(step.dataset.qtyStep);
    input.value = Math.max(Number(input.min || 1), next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Direct Buy Now checkout ---------------- */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-direct-checkout]');
    if (!button) return;
    event.preventDefault();
    if (button.getAttribute('aria-disabled') === 'true' || button.disabled) return;
    var form = button.closest('form');
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    var quantityInput = form.querySelector('[name="quantity"]');
    var errorBox = form.querySelector('[data-direct-checkout-error]');
    if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
    var variantId = idInput && idInput.value;
    var quantity = Math.max(1, Number(quantityInput && quantityInput.value || 1));
    if (!variantId) {
      if (errorBox) { errorBox.textContent = 'Please select an available option.'; errorBox.hidden = false; }
      return;
    }
    setButtonLoading(button, true, 'Preparing checkout…');
    button.disabled = true;
    fetch(window.routes.cart_url + '/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Could not prepare checkout. Please try again.');
        return fetch(window.routes.cart_add_url + '.js', {
          method: 'POST', headers: { Accept: 'application/json' },
          body: new URLSearchParams({ id: variantId, quantity: String(quantity) })
        });
      })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body.description || 'This product is currently unavailable.');
          return body;
        });
      })
      .then(function () { window.location.assign('/checkout'); })
      .catch(function (error) {
        if (errorBox) { errorBox.textContent = error.message || 'Unable to start checkout. Please try again.'; errorBox.hidden = false; }
        button.disabled = false;
        setButtonLoading(button, false);
      });
  });

  /* ---------------- Product variants ---------------- */
  $$('[data-variant-picker]').forEach(function (picker) {
    var form = document.getElementById(picker.dataset.formId);
    var data = JSON.parse(picker.querySelector('[data-variant-json]').textContent);
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.getElementById(picker.dataset.priceId);
    var button = form.querySelector('[type="submit"]');

    picker.addEventListener('change', function () {
      var chosen = $$('input:checked', picker).map(function (input) { return input.value; });
      var match = data.variants.find(function (variant) {
        return variant.options.every(function (option, index) { return option === chosen[index]; });
      });

      if (!match) {
        button.setAttribute('aria-disabled', 'true');
        button.textContent = window.strings.unavailable;
        return;
      }

      idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = match.price_html;
      button.removeAttribute('aria-disabled');
      button.textContent = match.available ? window.strings.addToCart : window.strings.soldOut;
      if (!match.available) button.setAttribute('aria-disabled', 'true');

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    });
  });

  /* ---------------- Product gallery ---------------- */
  $$('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    gallery.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-gallery-thumb]');
      if (!thumb || !main) return;
      main.src = thumb.dataset.full;
      main.srcset = thumb.dataset.fullSrcset || '';
      main.alt = thumb.dataset.alt || main.alt;
      $$('[data-gallery-thumb]', gallery).forEach(function (item) {
        item.setAttribute('aria-current', item === thumb ? 'true' : 'false');
      });
    });
  });

  /* ---------------- Tabs ---------------- */
  $$('[data-tabs]').forEach(function (group) {
    var tabs = $$('[role="tab"]', group);
    var panels = $$('[role="tabpanel"]', group);
    if (!tabs.length) return;

    function select(name, focusTab) {
      tabs.forEach(function (tab) {
        tab.setAttribute('aria-selected', tab.dataset.tab === name ? 'true' : 'false');
        if (tab.dataset.tab === name && focusTab) tab.focus();
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.dataset.panelName !== name;
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        select(tab.dataset.tab);
        if (history.replaceState) history.replaceState({}, '', '#' + tab.dataset.tab);
      });
      tab.addEventListener('keydown', function (event) {
        var i = tabs.indexOf(tab);
        var next = null;
        if (event.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (event.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (event.key === 'Home') next = tabs[0];
        if (event.key === 'End') next = tabs[tabs.length - 1];
        if (!next) return;
        event.preventDefault();
        select(next.dataset.tab, true);
      });
    });

    var fromHash = window.location.hash.replace('#', '');
    var valid = tabs.some(function (t) { return t.dataset.tab === fromHash; });
    select(valid ? fromHash : tabs[0].dataset.tab);

    window.addEventListener('hashchange', function () {
      var name = window.location.hash.replace('#', '');
      if (tabs.some(function (t) { return t.dataset.tab === name; })) select(name);
    });
  });

  /* ---------------- Header shrink on scroll ---------------- */
  var header = $('.header');
  if (header) {
    var ticking = false;
    var setHeaderState = function () {
      header.setAttribute('data-scrolled', window.scrollY > 40 ? 'true' : 'false');
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(setHeaderState);
    }, { passive: true });
    setHeaderState();
  }

  /* ---------------- Scroll reveals ---------------- */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -60px 0px' });
    $$('.reveal').forEach(function (el) { observer.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Keep drawers usable after a theme-editor section reload */
  document.addEventListener('shopify:section:load', function () {
    $$('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  });

  /* ---------------- Mobile sticky product purchase ---------------- */
  var stickyBuy = $('[data-sticky-buy]');
  var stickyTrigger = $('[data-sticky-buy-trigger]');
  var primaryBuy = $('[data-direct-checkout]');
  if (stickyBuy && stickyTrigger && primaryBuy) {
    var updateStickyBuy = function () {
      var rect = primaryBuy.getBoundingClientRect();
      var primaryVisible = rect.bottom > 0 && rect.top < window.innerHeight;
      stickyBuy.hidden = !(window.innerWidth <= 749 && !primaryVisible);
    };
    stickyTrigger.addEventListener('click', function () { primaryBuy.click(); });
    window.addEventListener('scroll', updateStickyBuy, { passive: true });
    window.addEventListener('resize', updateStickyBuy);
    updateStickyBuy();
  }
})();
